'use client';

import { usePathname } from 'next/navigation';

/** True na trasach ekranu TV (/[locale]/tv*) — globalne widgety/UI się tam chowają. */
export function useIsTvRoute() {
  const pathname = usePathname() || '';
  return /^\/[a-z]{2}\/tv(\/|$)/.test(pathname);
}

export default useIsTvRoute;
